import { $t } from "@/plugins/i18n";
const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: $t("menus.pureLogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/agreement/user",
    name: "UserAgreement",
    component: () => import("@/views/agreement/user.vue"),
    meta: {
      title: $t("menus.pureLogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/h5/recharge",
    name: "RechargeH5",
    component: () => import("@/views/rechargeH5/index.vue"),
    meta: {
      title: "充值米粒",
      showLink: false,
      rank: 104,
      requiresAuth: false
    }
  },
  {
    path: "/agreement/privacy",
    name: "PrivacyAgreement",
    component: () => import("@/views/agreement/privacy.vue"),
    meta: {
      title: $t("menus.pureLogin"),
      showLink: false,
      rank: 103
    }
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      title: $t("status.pureLoad"),
      showLink: false,
      rank: 102
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/layout/redirect.vue")
      }
    ]
  }
] satisfies Array<RouteConfigsTable>;
